// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__3cXab","pageBtn":"PaginationComp_pageBtn__33lro","active":"PaginationComp_active__7UsFT","ellipsis":"PaginationComp_ellipsis__nNi9u"};